(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
(function () {
  function initRow(root) {
    var row = root.querySelector('.tbt-rec');
    if (!row || row.dataset.ready) return;
    row.dataset.ready = '1';
    var track = row.querySelector('.tbt-rec__track');
    var arrows = row.querySelectorAll('.tbt-rec__arrow');
    function update() {
      if (!arrows.length) return;
      arrows[0].disabled = track.scrollLeft <= 4;
      arrows[1].disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }
    arrows.forEach(function (b) {
      b.addEventListener('click', function () {
        track.scrollBy({ left: parseInt(b.dataset.dir, 10) * track.clientWidth * 0.8, behavior: 'smooth' });
      });
    });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();

    // Cart icon: add to cart the same way the theme's own Add to cart does (header count,
    // cart drawer or notification), falling back to a normal form post
    row.querySelectorAll('.tbt-rec__cart').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch || !window.theme || !theme.routes) return;
        e.preventDefault();
        var btn = form.querySelector('button');
        btn.setAttribute('aria-busy', 'true');
        var formData = new FormData(form);
        var toUpdate = ['page-header', 'cart-drawer'].map(function (sel) { return document.querySelector(sel); }).filter(Boolean);
        formData.append('sections_url', window.location.pathname);
        formData.append('sections', toUpdate.map(function (el) { return el.dataset.sectionId; }).join(','));
        fetch(theme.routes.cartAdd, { method: 'POST', headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: formData })
          .then(function (r) { return r.json().then(function (data) { if (!r.ok) throw data; return data; }); })
          .then(function (data) {
            if (data.sections) {
              toUpdate.forEach(function (el) {
                if (el.updateFromCartChange && data.sections[el.dataset.sectionId]) el.updateFromCartChange(data.sections[el.dataset.sectionId]);
              });
            } else {
              form.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
            }
            var after = theme.settings && theme.settings.afterAddToCart;
            if (after === 'notification' && document.getElementById('AddedNotification')) {
              var note = document.getElementById('AddedNotification').content.firstElementChild.cloneNode(true);
              note.dataset.productTitle = data.product_title;
              (document.querySelector('.pageheader--sticky') || document.body).appendChild(note);
            } else if (after === 'drawer' && document.querySelector('.js-cart-drawer')) {
              document.querySelector('.js-cart-drawer').open(btn);
            } else if (after === 'page') {
              window.location.href = theme.routes.cart;
            }
            form.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { variantId: data.variant_id } }));
            btn.classList.add('is-added');
            setTimeout(function () { btn.classList.remove('is-added'); }, 2000);
          })
          .catch(function (err) {
            alert((err && (err.description || err.message)) || 'Sorry, this could not be added to your cart.');
          })
          .finally(function () { btn.removeAttribute('aria-busy'); });
      });
    });
  }

  function load() {
    var section = document.querySelector('.related-products');
    if (!section) return;
    initRow(section);
    var request = new XMLHttpRequest();
    request.open('GET', section.dataset.url);
    request.onload = function () {
      if (request.status < 200 || request.status >= 300) return;
      var container = document.createElement('div');
      container.innerHTML = request.response;
      var fresh = container.querySelector('.related-products');
      // Keep the same-collection strands if Shopify has no recommendations
      if (!fresh || !fresh.querySelector('.tbt-rec__item')) return;
      section.innerHTML = fresh.innerHTML;
      initRow(section);
    };
    request.send();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) load();
  });
  load();
})();

  } catch(e) { console.error(e); }
})();
})();
